import { message } from 'antd';
import { NotificationPlacement, IconType } from 'antd/es/notification';
import React from 'react';
import EWeChat from '@/assets/images/public/e-wechat.svg';

export interface ArgsProps {
  className?: string;
  /** 类型*/
  type?: IconType;
  /** 错误提示标题 */
  title?: string;
  /** 主要信息 */
  primaryText: string;
  /** 次要信息 */
  secondaryText?: string;
  /** 待拷贝信息，默认值为：主要信息+次要信息 */
  copyText?: string;
  /** 复制按钮标题，默认值为：复制错误信息 */
  copyBtnTitle?: string;
  /** 提示框展示位置，默认为：top */
  placement?: NotificationPlacement;
}

/**
 * 错误反馈弹框（包含弹框标题，主要信息与次要信息，支持指定待复制的信息）
 * 参考场景：接口出错需要弹框展示错误信息，以便用户更精准地反馈错误信息
 */
class CopyableNotification {
  public show(args: ArgsProps) {
    const { primaryText, secondaryText, copyText } = args;
    const openWX = () => {
      const text = copyText || `${primaryText}|${secondaryText}`;
      navigator.clipboard.writeText(text);
      message.success('已复制到剪切板，即将跳转小助手');
      setTimeout(() => {
        const a = document.createElement('a');
        a.href = 'wxwork://message?uin=8444251803319680';
        a.click();
      }, 1000);
    };
    message.info({
      content: <span>
        {primaryText}
        <span onClick={openWX} className={'flex-initial text-[#0A6CFF] cursor-pointer'}>
          <img className={'w-[16px] ml-[4px] mr-[2px] align-text-top'} src={EWeChat} alt={''}/>
          <span>Bugly小助手</span>
        </span>
    </span> });
  }
}

const copyableNotification = new CopyableNotification();
export { copyableNotification };
